import {
  getFilter,
  getLabel,
  getSort,
} from '../../Common/DataTable/tableHelpers';
import moment from 'moment';

const money = ({ value }) => `€ ${isFinite(value) ? value.toFixed(2) : 0}`;
// ctr and conversionRate are ratios (0.025), shown as percentages (2.50 %).
const percentage = ({ value }) =>
  `${isFinite(value) ? (value * 100).toFixed(2) : 0} %`;

const createTableColumns = (campaigns) => [
  {
    title: 'Campaign',
    name: 'campaignId',
    width: 180,
    formatterComponent: ({ value }) => getLabel(value, campaigns),
    sorting: (a, b) => getSort(getLabel(a, campaigns), getLabel(b, campaigns)),
    filter: (value, filter) =>
      getFilter(getLabel(value, campaigns), filter.value),
  },
  {
    title: 'Day',
    name: 'date',
    formatterComponent: ({ value }) => moment(value).format('dddd, DD/MM/YYYY'),
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(moment(value).format('dddd, DD/MM/YYYY'), filter.value),
  },
  {
    title: 'Leads',
    name: 'totalLeads',
  },
  {
    title: 'Spend',
    name: 'totalSpend',
    formatterComponent: money,
  },
  {
    title: 'Cost per Lead',
    name: 'costPerLead',
    formatterComponent: money,
  },
  {
    title: 'TikTok Ads Running',
    name: 'totalAdActiveCount',
  },
  {
    title: 'Impressions',
    name: 'totalImpressions',
    hidden: true,
  },
  {
    title: 'Clicks',
    name: 'totalClicks',
    hidden: true,
  },
  {
    title: 'CTR',
    name: 'ctr',
    formatterComponent: percentage,
  },
  {
    title: 'Conversion Rate',
    name: 'conversionRate',
    formatterComponent: percentage,
  },
  {
    title: 'eCPC',
    name: 'averageCpc',
    formatterComponent: money,
  },
];

export default createTableColumns;
